import { atom } from "recoil";
import { GridElement } from "../types/gridElement";

// Firebaseを複数更新する際のデータを管理
export const gridStore = atom<GridElement[][]>({
  key: "grid",
  default: [[]],
});
